import { API } from 'aws-amplify';
const apiName = process.env.VUE_APP_AWS_API_NAME;
import store from '../state/store';

var requestInfo = {
  headers: {
    'Authorization': '',
    'Content-Type': 'application/json'
  }
};

export default class ApiService {
  setHeaders() {
    if(store.state.auth.currentUser){
      requestInfo.headers.Authorization = store.state.auth.currentUser.jwtToken;
    }
  }

  get(path, query) {
    this.setHeaders();
    delete requestInfo.queryStringParameters;
    delete requestInfo.body;

    if(query) requestInfo.queryStringParameters = query;    
    return API.get(apiName, path, requestInfo);
  }

  post(path, params, query = null) {
    this.setHeaders();
    delete requestInfo.queryStringParameters;
    delete requestInfo.body;

    requestInfo.body = params;
    if(query) requestInfo.queryStringParameters = query;
    return API.post(apiName, path, requestInfo);
  }
}